module.exports = __webpack_public_path__ + "img/chance_closed.626369f0.png";